import React, { useEffect, useRef } from "react";
import classes from "./SpotForm.module.css";
import { RadioGroup, RadioGroupItem } from "../../../components/ui/radio-group";
import { Label } from "../../../components/ui/label";

const SpotForm = ({ spotFormViewModel, formRef, onFormSubmitted, initiatePayment }) => {

  const name = useRef(null);
  const contactNumber = useRef(null);
  const email = useRef(null);
  let selectedDate = useRef(null);

  useEffect(() => {
    selectedDate.current = spotFormViewModel.tripDates[0];
  }, [spotFormViewModel]);

  const submitHandler = () => {
    onFormSubmitted(name.current.value, contactNumber.current.value, email.current.value, selectedDate.current)
    name.current.value = "";
    contactNumber.current.value = "";
    email.current.value = "";
    selectedDate.current = spotFormViewModel.tripDates[0];
  };

  const BookingHandler = () => {
    if (
      !name.current.value ||
      !contactNumber.current.value ||
      !email.current.value
    ) {
      alert("Please fill all the fields");
      return;
    }
    initiatePayment(name.current.value, contactNumber.current.value, email.current.value,spotFormViewModel.bookingAmount);
  };

  return (
    <>
      <div ref={formRef} className={classes["form-container"]}>
        {/* <img className={classes['form-bg-img']} src="https://static.wixstatic.com/media/da937f_71fa99456de64f4ca0dacd3c15e0f8df~mv2.webp" alt="" /> */}
        <p className={classes["form-waiting-text"]}>
          What are you waiting for?
        </p>
        <div className={classes["form-inner-container"]}>
          <p className={classes["book-spot"]}>Book Your Spot</p>
          <input
            ref={name}
            className={classes["form-name-input"]}
            type="text"
            placeholder="Full Name"
          />

          <input
            ref={contactNumber}
            className={classes["form-name-input"]}
            type="text"
            placeholder="Phone No."
          />

          <input
            ref={email}
            className={classes["form-name-input"]}
            type="text"
            placeholder="Email"
          />

          <p className={classes["select-date"]}>Select Date:</p>
          <div className={classes["option-container"]}>
          <RadioGroup className="my-4" defaultValue="0">
            {spotFormViewModel.tripOptionDates.map((td, index) => (
              <div key={index} className="flex items-center space-x-2">
                <RadioGroupItem
                  className="h-6 w-6"
                  id={index.toString()}
                  name="date"
                  value={index.toString()}
                  onClick={() => {
                    selectedDate.current = spotFormViewModel.tripDates[index];
                  }}
                />
                <Label htmlFor={index.toString()}>{td}</Label>
              </div>
            ))}
          </RadioGroup>
          </div>
          <button
            onClick={submitHandler}
            className={classes["trip-form-submit"]}
          >
            Submit
          </button>
        </div>
      </div>
    </>
  );
};

export default SpotForm;
